const userQueryKeys = {
  all: ["user"] as const,
  user: () => [...userQueryKeys.all, "userData"] as const,
};

export default userQueryKeys;
